import { Component, ViewChild } from "@angular/core";
import { GoogleMap, MapInfoWindow, MapMarker } from "@angular/google-maps";

import { SearchResultItemModel } from "../../models/search-result-item.model";

import { MapMarkerModel } from "./map-marker.model";

import Animation = google.maps.Animation;
import LatLngBounds = google.maps.LatLngBounds;
import LatLngLiteral = google.maps.LatLngLiteral;
import MapOptions = google.maps.MapOptions;
import MapTypeId = google.maps.MapTypeId;

@Component({
    selector: "[pcg-ng-map-view]",
    templateUrl: "./map-view.component.html"
})
export class MapViewComponent {
    private static readonly DEFAULT_LOCATION: LatLngLiteral = {
        lat: 51.865278,
        lng: -2.245833
    };
    private static readonly DEFAULT_ZOOM: number = 13;

    public location: LatLngLiteral = MapViewComponent.DEFAULT_LOCATION;
    public options: MapOptions = {
        mapTypeId: MapTypeId.ROADMAP,
        disableDoubleClickZoom: true,
        scrollwheel: false,
        zoomControl: true,
        minZoom: 5,
        maxZoom: 20
    };
    public zoom: number = MapViewComponent.DEFAULT_ZOOM;

    @ViewChild("mapElement", { static: false })
    public mapComponentRef: GoogleMap;

    @ViewChild(MapInfoWindow, { static: false })
    public infoWindowRef: MapInfoWindow;

    public markers: Array<MapMarkerModel> = [];

    public selectedMarkerLocation: LatLngLiteral;
    public selectedMarkerContent: string;

    private _isMapInitialized: boolean = false;

    public initializeMap(): void {
        if (this._isMapInitialized) {
            return;
        }

        // navigator.geolocation.getCurrentPosition(position => {
        //     this.location = {
        //         lat: position.coords.latitude,
        //         lng: position.coords.longitude
        //     };
        // }, error => {
        //     console.warn(error.message);
        // });

        this._isMapInitialized = true;
    }

    public setMapCenter(latitude: number, longitude: number): void {
        this.location = { lat: latitude, lng: longitude };
    }

    public updateMapMarkers(pageItems: Array<SearchResultItemModel>): void {
        if (!this._isMapInitialized) {
            this.initializeMap();
        }

        this.markers = [];

        const bounds = new LatLngBounds();

        pageItems.forEach((model: SearchResultItemModel) => {
            if (model.latitude && model.longitude) {
                // const pageUrl = `${model.url}?returnUrl=${encodeURIComponent(window.location.href)}`;
                const pageUrl = `${model.url}`;

                const markerLocation = { lat: model.latitude, lng: model.longitude };
                const markerContent = "<div class='pcg-google-map-info-window'>"
                    + `<a href='${pageUrl}' class='pcg-google-map-info-window__title'>${model.name}</a>`
                    + (model.organizer ? `<br/><span><b>Organizer:</b> ${model.organizer}</span>` : "")
                    + (model.location ? `<br/><span><b>Location:</b> ${model.location}</span>` : "")
                    + (model.eventDate ? `<br/><span><b>Date:</b> ${model.eventDate}</span>` : "")
                    + ((!!model.eventDate && !!model.eventTime) ? `<br/><span><b>Time:</b> ${model.eventTime}</span>` : "")
                    + "</div>";

                this.markers.push({
                    position: markerLocation,
                    label: null,
                    title: model.name,
                    info: markerContent,
                    options: {
                        animation: Animation.DROP,
                        draggable: false
                    }
                });

                bounds.extend(markerLocation);
            }
        });

        setTimeout(() => {
            if (this.markers.length) {
                this.mapComponentRef.fitBounds(bounds, 0);
            } else {
                this.setMapCenter(MapViewComponent.DEFAULT_LOCATION.lat, MapViewComponent.DEFAULT_LOCATION.lng);
                this.zoom = MapViewComponent.DEFAULT_ZOOM;
            }
        });
    }

    public onZoomChanged(): void {
        this.zoom = this.mapComponentRef.getZoom();
    }

    public onMapMarkerClicked(markerElement: MapMarker, markerModel: MapMarkerModel): void {
        this.selectedMarkerLocation = markerModel.position;
        this.selectedMarkerContent = markerModel.info;

        this.infoWindowRef.open(markerElement);
    }

    public onInfoWindowClosing(): void {
        this.selectedMarkerLocation = null;
        this.selectedMarkerContent = null;
    }
}
